import _default from './Menu';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ../node_modules/semantic-ui-react/dist/es/collections/Menu/index.js
// module id = 853
// module chunks = 0